import * as React from 'react';
import {useState, useCallback} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Input, Snackbar, Alert} from "@mui/material";
import {useNavigate} from "react-router-dom";
import {makeApiCall} from "../../hooks/CancellableApiCall";
import EditNoteIcon from "@mui/icons-material/EditNote";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";

interface EditFormProps {
    id: number,
    content: string,
    startDate: string,
    endDate: string,
    communityId: string
}

type alertType = "success" | "error" | "info"

export default function EditActivityNoticeForm(props: EditFormProps) {
    const [open, setOpen] = useState(false);
    const [reason, setReason] = useState(props.content)
    const navigate = useNavigate()
    const [startDate, setStateDate] = useState(dayjs(props.startDate))
    const [endDate, setEndDate] = useState(dayjs(props.endDate))
    const [showAlert, setShowAlert] = useState(false)
    const [alertType, setAlertType] = useState<alertType>("success")
    const [alertText, setAlertText] = useState("")

    const setAlert = useCallback((type: alertType, text: string) => {
        setAlertType(type)
        setAlertText(text)
        setShowAlert(true)
    }, [setAlertType, setAlertText, setShowAlert])

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <EditNoteIcon color={"info"} onClick={() => setOpen(true)}/>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Edit Reason</DialogTitle>
                <DialogContent>
                    <Input multiline rows={3} value={reason} size="small" sx={{width: 500}}
                           onChange={(event) => setReason(event.target.value)}
                    ></Input>
                </DialogContent>
                <DialogContent>
                    <DialogContentText>Start Date</DialogContentText>
                    <DatePicker
                        defaultValue={startDate}
                        views={['year', 'month', 'day']}
                        onChange={(event) => {setStateDate(event!!)}}
                    />
                </DialogContent>
                <DialogContent>
                    <DialogContentText>End Date</DialogContentText>
                    <DatePicker
                        defaultValue={endDate}
                        views={['year', 'month', 'day']}
                        onChange={(event) => {setEndDate(event!!)}}
                    />
                </DialogContent>
                <DialogActions>
                    <Button color={"warning"} onClick={handleClose}>Cancel</Button>
                    <Button color={"info"} onClick={() =>
                        makeApiCall({
                            url: `/api/activity/${props.communityId}/${props.id}/edit`,
                            method: "PATCH",
                            body: {
                                newReason: reason,
                                newStartDate: startDate!.toISOString(),
                                newEndDate: endDate!.toISOString(),
                            },
                            onLoadedCallback: () => {
                                navigate(`/user/${props.communityId}`)
                            },
                            onError: () => {
                                setAlert("error", "Failed to edit")
                            }
                        })
                    }>Edit</Button>
                </DialogActions>
            </Dialog>
            <Snackbar open={showAlert} autoHideDuration={5000} onClose={() => setShowAlert(false)}>
                <Alert severity={alertType} onClose={() => setShowAlert(false)} sx={{width: "100%"}} variant="filled">
                    {alertText}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}